import { createContext } from './create-context';
import { createSplitProps } from './create-split-props';
export const [RenderStrategyProvider, useRenderStrategyContext] = createContext({
    hookName: 'useRenderStrategyContext',
    providerName: '<RenderStrategyProvider />',
});
export const splitRenderStrategyProps = (props) => createSplitProps()(props, ['lazyMount', 'unmountOnExit']);
